import type { SVGProps } from 'react';

const StarAIIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.25065 16.2904C3.85945 16.2904 3.54232 15.9732 3.54232 15.582C3.54232 15.1908 3.85945 14.8737 4.25065 14.8737C4.64185 14.8737 4.95898 15.1908 4.95898 15.582C4.95898 15.9732 4.64185 16.2904 4.25065 16.2904Z"
      fill="currentColor"
    />
    <path
      d="M12.7507 2.1237C12.3595 2.1237 12.0423 1.80657 12.0423 1.41536C12.0423 1.02416 12.3595 0.707031 12.7507 0.707031C13.1419 0.707031 13.459 1.02416 13.459 1.41536C13.459 1.80657 13.1419 2.1237 12.7507 2.1237Z"
      fill="currentColor"
    />
    <path
      d="M15.584 4.95703C15.1928 4.95703 14.8757 4.6399 14.8757 4.2487C14.8757 3.8575 15.1928 3.54036 15.584 3.54036C15.9752 3.54036 16.2923 3.8575 16.2923 4.2487C16.2923 4.6399 15.9752 4.95703 15.584 4.95703Z"
      fill="currentColor"
    />
    <path
      d="M7.57611 3.55918C7.8112 2.58965 9.1901 2.58965 9.4252 3.55918L10.0721 6.22691C10.156 6.57306 10.4263 6.84333 10.7724 6.92727L13.4402 7.57415C14.4097 7.80925 14.4097 9.18815 13.4402 9.42324L10.7724 10.0701C10.4263 10.1541 10.156 10.4243 10.0721 10.7705L9.4252 13.4382C9.1901 14.4077 7.8112 14.4077 7.57611 13.4382L6.92922 10.7705C6.84528 10.4243 6.57502 10.1541 6.22886 10.0701L3.56113 9.42324C2.5916 9.18815 2.5916 7.80925 3.56113 7.57415L6.22886 6.92727C6.57502 6.84333 6.84528 6.57306 6.92922 6.22691L7.57611 3.55918Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8069 10.6204C16.1368 10.7435 16.3044 11.1107 16.1812 11.4406C15.3838 13.5772 13.7282 15.2935 11.6335 16.1701C11.3087 16.306 10.9352 16.1529 10.7993 15.8281C10.6634 15.5034 10.8165 15.1299 11.1413 14.994C12.9118 14.253 14.3127 12.8007 14.9867 10.9947C15.1098 10.6649 15.477 10.4973 15.8069 10.6204Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.39037 1.19198C6.51374 1.52174 6.34642 1.88908 6.01666 2.01245C4.20075 2.69182 2.74241 4.10909 2.00702 5.89957C1.87325 6.22525 1.50079 6.38083 1.17511 6.24706C0.849432 6.1133 0.693854 5.74084 0.82762 5.41516C1.69735 3.29762 3.42047 1.62243 5.5699 0.818282C5.89966 0.694912 6.267 0.862224 6.39037 1.19198Z"
      fill="currentColor"
    />
    <path
      d="M1.41732 13.457C1.02612 13.457 0.708984 13.1399 0.708984 12.7487C0.708984 12.3575 1.02612 12.0404 1.41732 12.0404C1.80852 12.0404 2.12565 12.3575 2.12565 12.7487C2.12565 13.1399 1.80852 13.457 1.41732 13.457Z"
      fill="currentColor"
    />
  </svg>
);

export default StarAIIcon;
